export const TRACK_SHARE = 'TRACK_SHARE';
export const TRACK_404 = 'TRACK_404';
export const TRACK_500 = 'TRACK_500';

export const trackShare = ({ url, sharedVia }) => ({
  type: TRACK_SHARE,
  payload: { url, sharedVia },
});

export const track404 = ({ path }) => ({
  type: TRACK_404,
  payload: { path },
});

export const track500 = ({ path }) => ({
  type: TRACK_500,
  payload: { path },
});



// WEBPACK FOOTER //
// ./src/actions/trackingActions.js